module.exports = __webpack_public_path__ + "static/media/star.78c88e8d.webp";